// Global Instructions Rule Applied!

export const SET_FILTER_OPTIONS = 'funds/SET_FILTER_OPTIONS' as const
export const SET_FUNDS = 'funds/SET_FUNDS' as const
export const SET_ACTIVE_FILTERS = 'funds/SET_ACTIVE_FILTERS' as const
export const SET_ACTIVE_SORTING = 'funds/SET_ACTIVE_SORTING' as const
export const CLEAR_ACTIVE_FILTERS = 'funds/CLEAR_ACTIVE_FILTERS' as const
export const CLEAR_ACTIVE_SORTING = 'funds/CLEAR_ACTIVE_SORTING' as const
export const UPDATE_FUND_RECORD = 'funds/UPDATE_FUND_RECORD' as const
export const ADD_FUND = 'funds/ADD_FUND' as const
export const APPEND_FUNDS = 'funds/APPEND_FUNDS' as const
